export default {
    contractList: {
        title: 'Active contracts',
        newContractAria: 'Create new contract',
        loadErrorTitle: "Couldn't load contracts",
        loadErrorBody: 'Network error — please try again',
        tryAgain: 'Try again',
        emptyTitle: 'No active contracts',
        emptyBody: 'Create your first contract with the form on the right.',
        emptyCta: 'Create your first contract',
        filterEmptyTitle: 'No contracts match these filters',
        filterEmptyBody: 'Try clearing the filter or expanding the date range.',
        clearFilters: 'Clear filters',
    },
}
